import React from 'react';
import ContainerTemplate from '../../../widgets/template/Container';
import ConceptosView from './ConceptosView';
import * as ROUTES from '../../../router/Routes';

const ConceptosModule = () => {
  return (
    <ContainerTemplate
      active={ROUTES.conceptos}
      routes={[ROUTES.administracion]}
    >
      <ConceptosView />
    </ContainerTemplate>
  );
};

export default ConceptosModule;
